import api from './api';

export const register = (data) => api.post('/auth/register', data);
export const changePassword = (data) => api.put('/auth/change-password', data);
export const loginRequest = (data) => api.post('/auth/login', data);
export const logoutRequest = (refreshToken) => api.post('/auth/logout', { refreshToken });
export const addRoleRequest = (role) => api.post('/auth/roles', { role });
